<footer class="bg-dark text-white">
  <div
    class="d-flex justify-content-center align-items-center bg-light text-dark font-italic pl-30 pr-30 pt-30 pb-30"
  >
    To comply with the Combat Meth Epidemic Act of 2005, we electronically
    monitor sales of products containing ephedrine, pseudoephedrine, and
    phenylpropanolamine.
  </div>
  <div
    class="d-flex flex-column flex-xl-row justify-content-between align-items-center pb-3 pt-5 px-5"
  >
    <div class="links font-weight-bold mb-4 mb-xl-0">
      <a
        href="https://www.equifax.com/personal/accessibility-statement/"
        target="_blank"
        rel="noopener"
        class="text-white mr-3"
        >Accessibility</a
      >
      <a
        href="https://www.equifax.com/privacy/"
        target="_blank"
        rel="noopener"
        class="text-white mr-3"
        >Privacy Policy</a
      >
      <a
        href="https://www.equifax.com/terms/"
        target="_blank"
        rel="noopener"
        class="text-white"
        >Terms of Use</a
      >
    </div>
    <div class="social d-flex">
      <a
        aria-label="X"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
        class="pr-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
          />
        </svg>
      </a>
      <a
        aria-label="linkedin"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
        class="pr-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
          />
        </svg>
      </a>
      <a
        aria-label="Facebook"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
        class="pr-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
          />
        </svg>
      </a>
      <a
        aria-label="youTube"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
        class="pr-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"
          />
        </svg>
      </a>
      <a
        aria-label="instagram"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
        class="pr-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
          />
        </svg>
      </a>
      <a
        aria-label="rss"
        href="https://www.equifax.com/follow-us"
        target="_blank"
        rel="noopener"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          height="20"
          width="20"
        >
          <path
            fill="#FFFFFF"
            d="M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
          />
        </svg>
      </a>
    </div>
  </div>
  <div class="px-5">
    <hr />
  </div>
  <div class="copyright pt-3 pb-5 px-5">
    <div class="d-flex flex-column flex-xl-row align-items-center">
      <img
        src="assets/images/efx_logo_white.svg"
        alt="Equifax stock ticker logo"
        class="mb-4 mb-xl-0"
      />
      <p class="my-0 mx-4">
        Copyright {{ currentYear }} Equifax, Inc. All rights reserved Equifax
        and the Equifax marks used herein are trademarks of Equifax Inc. Other
        product and company names mentioned herein are the property of their
        respective owners.
      </p>
      <img
        src="assets/images/efx_powering_white.svg"
        alt="Equifax stock ticker logo"
        style="height: 29px"
        class="mt-4 mt-xl-0"
      />
    </div>
  </div>
</footer>
